module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Bold.76b8c78.woff2";